import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "avatar-img-wrap" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.link,
    custom: ""
  }, {
    default: _withCtx(({ navigate }) => [
      _createElementVNode("div", {
        class: "user-avatar",
        onClick: navigate
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.avatar,
            class: _normalizeClass(["avatar-img", { blur: _ctx.blur }])
          }, null, 10, _hoisted_3)
        ])
      ], 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to"]))
}